export default __webpack_public_path__ + "static/media/GHSI Risk Oversight Charter.e95711e4.pdf";